export default __webpack_public_path__ + "static/media/nini.a640519f.jpg";